import { StyleProp, ViewStyle } from 'react-native';

export type ChallengeHomeCardProps = {
  challenges: {
    id: string;
    image: string;
    accessibilityLabel: string;
    imageWidth: number;
    onPress: () => void;
  }[];
  style?: StyleProp<ViewStyle>;
  testID?: string;
};
